import { useMemo } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';

import { BrandVoicesStore } from './BrandVoicesStore';

const useBrandVoicesState = createStateSelectorHook(BrandVoicesStore, [
  'brandVoicesAssets',
  'loadingBrandVoiceAssets',
  'defaultBrandVoice',
]);

export const useDefaultBrandVoiceAssets = () => {
  const { brandVoicesAssets, loadingBrandVoiceAssets, defaultBrandVoice } = useBrandVoicesState();

  return useMemo(() => {
    if (loadingBrandVoiceAssets) {
      return {};
    }

    const alignedDefaultBrandVoice =
      (brandVoicesAssets || []).find((brandVoice) => brandVoice.id === defaultBrandVoice?.id) ||
      brandVoicesAssets[0];

    const { customModels, toneOfVoices } = alignedDefaultBrandVoice || {};

    return {
      customModels,
      toneOfVoices,
    };
  }, [defaultBrandVoice, brandVoicesAssets, loadingBrandVoiceAssets]);
};
